import React from 'react';
import { ShieldCheckIcon, MapPinIcon, PackageIcon, WalletIcon, SparklesIcon, HeartIcon, RefreshCwIcon, LogOutIcon, ChevronRightIcon, CreditCardIcon } from 'lucide-react';
interface AccountSidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
  isMobile?: boolean;
}
export function AccountSidebar({
  activeSection,
  onSectionChange,
  isMobile = false
}: AccountSidebarProps) {
  const menuItems = [{
    id: 'login-security',
    label: 'Login & Security',
    shortLabel: 'Security',
    icon: ShieldCheckIcon
  }, {
    id: 'addresses',
    label: 'Addresses',
    shortLabel: 'Addresses',
    icon: MapPinIcon
  }, {
    id: 'orders',
    label: 'My Orders',
    shortLabel: 'Orders',
    icon: PackageIcon
  }, {
    id: 'payment-requests',
    label: 'Payment Requests',
    shortLabel: 'Payments',
    icon: CreditCardIcon
  }, {
    id: 'wallet',
    label: 'My Wallet',
    shortLabel: 'Wallet',
    icon: WalletIcon
  }, {
    id: 'points',
    label: 'Loyalty Points',
    shortLabel: 'Points',
    icon: SparklesIcon
  }, {
    id: 'wishlist',
    label: 'Wishlist',
    shortLabel: 'Wishlist',
    icon: HeartIcon
  }, {
    id: 'returns',
    label: 'Returns',
    shortLabel: 'Returns',
    icon: RefreshCwIcon
  }];
  const handleSignOut = () => {
    if (window.confirm('Are you sure you want to sign out?')) {
      window.location.href = '/';
    }
  };
  if (isMobile) {
    return <div className="sticky top-[112px] z-10 bg-white border-b border-gray-200 shadow-sm overflow-x-auto scrollbar-hide" role="tablist" aria-label="Account sections" data-id="element-290" data-mp="1uhizo5eqyreu">
        <div className="flex gap-1 px-4 py-3 min-w-max" data-id="element-291" data-mp="j2chx064vgy3">
          {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = activeSection === item.id;
          return <button key={item.id} onClick={() => onSectionChange(item.id)} role="tab" aria-selected={isActive} aria-controls={`panel-${item.id}`} className={`flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all min-w-[72px] ${isActive ? 'bg-[#1E2B55] text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-292" data-mp="fk6nzsbrjc9q">
                <Icon className="w-5 h-5" data-id="element-293" data-mp="3sy9zohrtjoce" />
                <span className="text-xs font-medium whitespace-nowrap" data-id="element-294" data-mp="1knht52iib02">
                  {item.shortLabel}
                </span>
              </button>;
        })}
        </div>
      </div>;
  }
  return <div className="sticky top-24" data-id="element-295" data-mp="3nzq9g566zqe8">
      <nav className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-296" data-mp="3o0rnmiii8t06">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = activeSection === item.id;
        return <button key={item.id} onClick={() => onSectionChange(item.id)} className={`w-full flex items-center justify-between px-5 py-4 transition-all border-b border-gray-100 last:border-b-0 ${isActive ? 'bg-[#1E2B55] text-white' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-297" data-mp="2vdrxnequv395">
              <div className="flex items-center gap-3" data-id="element-298" data-mp="30c373od8nbqu">
                <Icon className="w-5 h-5" data-id="element-299" data-mp="3ecw6oniecx0t" />
                <span className="font-medium" data-id="element-300" data-mp="3ebujjko3wk2q">{item.label}</span>
              </div>
              <ChevronRightIcon className="w-5 h-5" data-id="element-301" data-mp="39ekwucs3qmil" />
            </button>;
      })}
        {/* Sign Out */}
        <button onClick={handleSignOut} className="w-full flex items-center justify-between px-5 py-4 text-red-600 hover:bg-red-50 transition-all" data-id="element-302" data-mp="3o1e20p7wqbx2">
          <div className="flex items-center gap-3" data-id="element-303" data-mp="x7yi2wgurxn">
            <LogOutIcon className="w-5 h-5" data-id="element-304" data-mp="vwvw6erbq84" />
            <span className="font-medium" data-id="element-305" data-mp="3t2la6pdypd49">Sign Out</span>
          </div>
        </button>
      </nav>
    </div>;
}